import React, { useEffect, useRef, useState } from "react";

interface props {
  isOpen: any;
  setIsOpen: (value: boolean) => void;
  onUnmatchClick: () => void;
  onReportClick: () => void;
}

const Menu = ({ isOpen, setIsOpen, onUnmatchClick, onReportClick }: props) => {
  const divRef = useRef<HTMLDivElement>(null);
  const menuItemClass =
    "hover:bg-[#C08193] hover:text-white flex items-center gap-2 font-semibold p-1 w-full cursor-pointer rounded-xl";

  const handleClickOutside = (event: MouseEvent) => {
    if (divRef.current && !divRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={divRef}
      className="flex flex-col items-start cursor-pointer relative w-full z-[200] min-w-24"
      onClick={() => setIsOpen(!isOpen)}
    >
      {isOpen && (
        <div className=" py-2 px-1 text-xs bg-py-bg-secondary rounded-lg text-py-text-primary absolute w-full top-full mt-2">
          <div className="flex flex-col items-start">
            <span className={menuItemClass} onClick={onReportClick}>
              Report
            </span>
            <span className={menuItemClass} onClick={onUnmatchClick}>
              Unmatch
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Menu;
